import { Image as RImage } from 'rebass';
import styled from 'styled-components';
import { maxWidth } from 'styled-system';

const Image = styled(RImage)`
  ${maxWidth}
`;

export default Image;
